import ListItem from '@mui/material/ListItem';
import { styled } from '@classify/react-core-components/styles';

const StyledListItem = styled(ListItem)(({ theme: { spacing } }) => ({
  marginTop: spacing(1),
  marginBottom: spacing(1),
}));

export default StyledListItem;
